export enum TaskTypeEnum {
  Undefined = 0,
  Approval = 1,
  List = 2,
  Function = 3,
  ValoremFunction = 4,
  ArgusFunction = 5,
  ArgusSyncFunction = 6,
  CloseValuationEvent = 7,
  ValuationEventFunction = 8,
  ValuationEffectiveDatesSetup = 9
}
